import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="border-y border-amber-200 bg-amber-50 text-center text-slate-900" aria-label="Limited time offer" data-id="element-206" data-mp="2sk46nkhn1yb1">
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-207" data-mp="36bsfnewlc6ns">
        <p className="inline-flex items-center gap-2 text-sm font-semibold text-amber-800" data-id="element-208" data-mp="31i6bkb4htb3l">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-209" data-mp="3g7c6vo07mh67" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-210" data-mp="3b7zdekeu2bun" />
        <p className="mt-7 font-medium text-slate-700" data-id="element-211" data-mp="3bb4zrrw2uzmo">After that the price increases and never drops again.</p>
      </div>
    </section>;
}